module.exports = __webpack_public_path__ + "img/app_store@2x.a0813e2d.png";